import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useApiMutation } from "../hooks/useApi";
import { SystemUser } from "../types/contact";

interface Props {
  handlePromoteOpen: (item: SystemUser) => void;
  handlePromoteClose: () => void;
  setPromoteOpen: React.Dispatch<React.SetStateAction<boolean>>;
  promoteOpen: boolean;
  selectedItem: SystemUser | null;
  setPromoted: React.Dispatch<React.SetStateAction<boolean>>;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const PromoteDialog: FunctionComponent<Props> = (props: Props): JSX.Element => {
  const {
    handlePromoteOpen,
    handlePromoteClose,
    promoteOpen,
    setPromoteOpen,
    selectedItem,
    setPromoted,
  } = props;

  const { apiUpdate } = useApiMutation();

  const { t } = useTranslation();

  const handlePromoteUser = () => {
    apiUpdate.mutate(
      {
        entity: "systemusers",
        post: {
          id: selectedItem?.id,
          uid: selectedItem?.uid,
          isPrimary: true,
        },
      },
      {
        onSuccess: () => {
          setPromoted(true);
          handlePromoteClose();
        },
        onError: (error) => console.error(error),
      }
    );
  };

  return (
    <BootstrapDialog
      onClose={handlePromoteClose}
      aria-labelledby="customized-dialog-title"
      open={promoteOpen}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {t("dialogs.promoteDialog.title", { contactName: selectedItem?.name })}
      </DialogTitle>

      <IconButton
        aria-label="close"
        onClick={handlePromoteClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        <Typography>
          {t("dialogs.promoteDialog.text1", {
            contactName: selectedItem?.name,
          })}
        </Typography>{" "}
        <br />
        <Typography>{t("dialogs.promoteDialog.text2")}</Typography>
      </DialogContent>

      <DialogActions>
        <Button autoFocus onClick={handlePromoteClose}>
          {t("buttons.cancel")}
        </Button>
        <Button variant="contained" onClick={handlePromoteUser}>
          {t("buttons.promote2")}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default PromoteDialog;
